<template>
	<div>
		<div class="label1" style="position: relative;height: 580px;">
			<el-image
			      style="width: 100%; height: 600px;position: absolute;top:0px;left:0px;z-index:50;"
			      :src="topImage"
			      fit="cover">
				<div slot="placeholder" style="text-align:center;padding-top:30%;font-size:12px;color:#909399;">
				  加载中...
				</div>
			</el-image>
			<div style="z-index:100;position: absolute;top:0px;left:0px;width: 100%;">
				
				<div style="margin-left: 20%;width: 60%;height: 400px;margin-top: 70px;">
					<div style="font-size: 22px;margin-bottom:10px;font-weight: bold;text-align: center;color:white;width:60%;" v-if="video.url != null">
						<div style="display: inline-block;padding:5px 30px 5px 30px;border-radius: 15px;background-color: #EBEEF5;color:#606266;">{{video.title}}</div>
					</div>
					<div class="messageBoxBack" v-if="video.url == null" style="height: 40px;padding:10px 20px 10px 20px;line-height: 40px;background-color: #EBEEF5;margin:10px 10px 0px 10px;border-radius: 8px;text-align: center;">
						暂无播放视频
					</div>
					
					
					<div v-if="video.url != null" style="width: 60%; height: 100%;vertical-align: top;display: inline-block;background-color: #606266;">
						<video  id="videoDiv"
							:src="video.url"
							width="100%"
							height="100%"
							controls
						  ></video>
					</div>
					<div v-if="video.url != null" style="height: 100%;width: 40%;display: inline-block;background-color: white;overflow:auto;">
						<div style="height: 50px;line-height: 50px;padding-left:20px;border-bottom: 1px solid #EBEEF5;font-weight: bold;">播放清单</div>
						
						<div class="messageBoxBack" @click="changeVideo(item)" v-for="item in videoList" style="height: 40px;padding:10px 20px 10px 20px;line-height: 40px;border: 1px solid #DCDFE6;margin:10px 10px 0px 10px;border-radius: 8px;cursor: pointer;">
							<!-- <el-image
							      style="width: 30%; height: 100%;vertical-align: top;"
							      :src="item.image"
							      fit="cover">
							<div slot="placeholder" style="text-align:center;padding-top:30%;font-size:12px;color:#909399;">
							  加载中...
							</div>	  
							</el-image> -->
							
							<div  style="display: inline-block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow: ellipsis;width: 67%;margin-left: 3%;font-size: 15px;">
								
								<span style="" v-if="item.title != video.title">{{item.title}}</span>
								<span style="font-weight: bold;" v-if="item.title == video.title">[正在播放]
								{{item.title}}</span>
							</div>
						</div>
						
					</div>
					<div v-if="video.url != null" style="color: white;font-size: 13px;">部分浏览器不支持自动播放，需要手动点击播放按钮</div>
				</div>
			</div>
		</div>
		
		<div class="label2" style="margin-top: 20px;padding-top:30px;font-size: 40px;padding-bottom:20px;border-bottom:1px solid #EBEEF5;margin-left: 20%;width: 60%;text-align: center;">
			{{title}}
		</div>
		<div style="margin-top: 20px;margin-left: 20%;text-align: left;width: 60%;padding-bottom: 50px;">
			
			<div v-if="downloadList.length == 0" class="messageBoxBack" style="border-radius: 8px;padding:10px;background-color: #EBEEF5;display: inline-block;margin-bottom:10px;"  >暂无下载内容</div>
			
			<div v-for="item in downloadList">
				<div class="messageBoxBack" style="border-radius: 8px;padding:10px;cursor: pointer;display: inline-block;margin-bottom:10px;color:#409EFF;"   @click="download(item.url)"><i class="el-icon-download" style="margin-right:5px;"></i>{{item.title}}</div>
			</div>
		</div>	
		
	</div>
</template>

<script>
	import utils from '@/utils';
	export default {
		name: '',
		data() {
			return {
				language:"Chinese",
				topImage:utils.fileUrl()+'serviceSupport/topImage.png',
				videoList:[
					{
						title:"7代起爆器培训视频",
						url:utils.fileUrl()+"serviceSupport/video4.mp4",
						image:utils.fileUrl()+'serviceSupport/topImage.png',
					},
					{
						title:"“雷心”电子雷管现场操作指导（高清）",
						url:utils.fileUrl()+"serviceSupport/video1.mp4",
						image:utils.fileUrl()+'serviceSupport/topImage.png',
					},
					{
						title:"6代起爆器操作培训视频",
						url:utils.fileUrl()+"serviceSupport/video2.mp4",
						image:utils.fileUrl()+'serviceSupport/topImage.png',
					},
					{
						title:"7代2.1操作培训视频（高清）",
						url:utils.fileUrl()+"serviceSupport/video3.mp4",
						image:utils.fileUrl()+'serviceSupport/topImage.png',
					},
					
				],
				downloadList:[
					{
						title:"7代起爆器1.0版本使用说明书",
						url:utils.fileUrl()+"serviceSupport/pdf1.pdf",
					},
					{
						title:"三码绑定机 使用手册（贵州全安密灵科技）",
						url:utils.fileUrl()+"serviceSupport/pdf8.pdf",
					},
					{
						title:"二十发模块成品检测仪2.0",
						url:utils.fileUrl()+"serviceSupport/pdf3.pdf",
					},
					{
						title:"六代起爆器使用说明书",
						url:utils.fileUrl()+"serviceSupport/pdf5.pdf",
					},
					{
						title:"桥丝感度测试仪-使用手册-201804081755",
						url:utils.fileUrl()+"serviceSupport/pdf7.pdf",
					},
					{
						title:"煤安起爆器产品说明书01010633",
						url:utils.fileUrl()+"serviceSupport/pdf6.pdf",
					},
					{
						title:"电子雷管群发检测系统使用手册V2019-01",
						url:utils.fileUrl()+"serviceSupport/pdf2.pdf",
					},
					{
						title:"脚线压接机使用说明书",
						url:utils.fileUrl()+"serviceSupport/pdf4.pdf",
					},
				],
				video:{
						title:"7代起爆器培训视频",
						url:utils.fileUrl()+"serviceSupport/video4.mp4",
						image:utils.fileUrl()+'serviceSupport/topImage.png',
				},
				
				title:"下载中心",
			}
		},
		methods: {
			changeVideo(item){
				this.video = item;
				document.getElementById("videoDiv").src=item.url;
				
			},
			download(url){
				window.open(url);
			}
		},
		mounted() {
			var that = this;
			setTimeout(function(){
			   that.type = that.$route.query.type;
			   that.$el.querySelector(".label"+that.$route.query.type).scrollIntoView({ block: "start", behavior: "smooth" });
			}, 300);
		}

	}
</script>
<style type="text/css">
	.messageBoxBack{
		cursor: pointer;
		transition: all 0.2s;
		-moz-transition: all 0.2s;
		/* Firefox 4 */
		-webkit-transition: all 0.2s;
		/* Safari å’Œ Chrome */
		-o-transition: all 0.2s;
		/* Opera */
	}
	
	.messageBoxBack:hover{
		background-color: #EBEEF5;
	}
</style>